const ClockHowToRead = () => {
  const pStyles = "text-slate-600";
  return (
    <div className="flex flex-col justify-center">
      <div className="p-5 text-center text-xl text-slate-600 font-medium">
        How to read the clock
      </div>
      <div className="p-5 text-left space-y-2 bg-stone-50 border rounded-md">
        <p className={pStyles}>
          The clock is composed of twenty-four colored sections, each of which
          is either in an illuminated 'ON' state or an unlit 'OFF' state, at any
          given moment. The illuminated sections are counted cumulatively, as
          described below, to read the time.
        </p>
        <p className={pStyles}>
          At the very top there is a yellow blinker that is lit when the clock
          seconds are an odd number, and is unlit when the clock seconds are an
          even number.
        </p>
        <p className={pStyles}>
          Below this is a row of four red elements, each of which represents
          five hours of time when illuminated.
        </p>
        <p className={pStyles}>
          Moving down, the next row is also four red elements, each of which
          represents a single hour of time when illuminated.
        </p>
        <p className={pStyles}>
          The next row down consists of eleven sections, of either red or yellow
          color when lit. Each of these represents five minutes of time. The
          third, sixth, and ninth elements are colored red, and can be used as a
          quick visual cue that either 15, 30, or 45 minutes have passed.
        </p>
        <p className={pStyles}>
          The bottom row contains four elements, yellow in color when lit, each
          of which represents a single minute of time.
        </p>
      </div>
    </div>
  );
};

export { ClockHowToRead };
